import * as React from 'react'
let openCount = 0
let scrollY = 0

export const useDialogManager = (isVisible: boolean) => {
    React.useEffect(() => {
        if (isVisible) {
            openCount += 1
            if (openCount === 1) {
                scrollY = window.scrollY
                document.body.style.top = `-${scrollY}px`
                document.body.classList.add('scrollSave')
            }
        }
        return () => {
            if (isVisible) {
                openCount = Math.max(openCount - 1, 0)
                if (openCount === 0) {
                    document.body.removeAttribute('style')
                    document.body.classList.remove('scrollSave')
                    window.scrollTo(0, scrollY)
                }
            }
        }
    }, [isVisible])
}
